module.exports = __webpack_public_path__ + "static/media/btn_apple_ja.62c2bca2.png";